// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../reason/clients/components/Labels.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let OwnRentalNeedStatusLabel_rentalNeedV5_graphql = require("../../__generated__/OwnRentalNeedStatusLabel_rentalNeedV5_graphql.bs.js");

let convertFragment = OwnRentalNeedStatusLabel_rentalNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment, fRef);
}

let RentalNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function OwnRentalNeedStatusLabel$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment, props.rentalNeed);
  let status = match.status;
  switch (status.__typename) {
    case "ActiveRentalNeed" :
      if (!status.isRenewable) {
        return JsxRuntime.jsx(Labels.ActiveStatusLabel.make, {});
      }
      let daysLeft = DateFns.differenceInCalendarDays(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(status.activeUntil)), new Date());
      return JsxRuntime.jsx(Labels.ExpiringStatusLabel.make, {
        expiringIn: Labels.stringOfExpiring(daysLeft)
      });
    case "ExpiredRentalNeed" :
      return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "RentedRentalNeed" :
      return JsxRuntime.jsx(Labels.RentedLabel.make, {});
    case "WithdrawnRentalNeed" :
      return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
      return null;
  }
}

let WithoutErrorBoundary = {
  make: OwnRentalNeedStatusLabel$WithoutErrorBoundary
};

function OwnRentalNeedStatusLabel(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "rentalNeed status",
    children: JsxRuntime.jsx(OwnRentalNeedStatusLabel$WithoutErrorBoundary, {
      rentalNeed: props.rentalNeed
    })
  });
}

let make = OwnRentalNeedStatusLabel;

exports.RentalNeedFragment = RentalNeedFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
